<template>
<div class="container px-0">
    <div
        v-if="!pdf_mode"
        class="main--content-header d-flex justify-content-between"
    >
        <svg-image
            svg_name="chevron-left"
            auto_hover
            spaced
            @click="back"
        >
            <span class="my-auto">Snag List</span>
        </svg-image>

        <div v-if="!loading">
            <a
                v-if="download_url != null"
                :href="download_url"
                class="btn btn-primary"
                style="max-height: 40px"
            >
                PDF
            </a>

            <button
                v-if="!form_submission.archived_at"
                class="btn btn-secondary"
                style="max-height: 40px"
                @click="archive"
            >
                Archive
            </button>

            <button
                v-else
                class="btn btn-secondary"
                style="max-height: 40px"
                @click="restore"
            >
                Restore
            </button>
        </div>
        <loader v-else></loader>
    </div>

    <div class="row">
        <template v-if="!loading">
            <div class="col-12 col-md-8">
                <snag-list-submission
                    :form_submission="form_submission"
                    :snag_list="form_submission.snag_list"
                    :pdf_mode="pdf_mode"
                />

                <div
                    v-if="form_submission.history.length > 0"
                    class="snag-list--ellipses"
                >
                    &hellip;
                </div>

                <template v-for="(submission, index) in form_submission.history">
                    <snag-list-submission
                        :form_submission="submission"
                        :snag_list="submission.snag_list"
                        :pdf_mode="pdf_mode"
                    />

                    <div
                        v-if="index + 1 < form_submission.history.length"
                        class="snag-list--ellipses"
                    >
                        &hellip;
                    </div>
                </template>
            </div>

            <div class="col-12 col-md-4">
                <Comments
                    :endpoint="comments_url"
                    :comments="form_submission?.comments_list"
                    :pdf_mode="pdf_mode"
                />
            </div>
        </template>

        <loader v-else></loader>
    </div>
</div>
</template>

<script>
import SnagListSubmission from "../submissions/SnagListSubmission";
import Loader from "../general_components/Loader";
import Comments from "../comments/Comments";

export default {
    name: "SnagListShowPage",
    components: {
        Loader,
        SnagListSubmission,
        Comments,
    },
    props: {
        form_submission: Object,
        archive_url: String,
        back_url: String,
        comments_url: String,
        download_url: String,
        restore_url: String,
        pdf_mode: Boolean,
    },
    data() {
        return {
            loading: false,
        };
    },

    methods: {
        back() {
            window.location.href = this.back_url + '/' + this.form_submission.snag_list.status;
        },

        archive() {
            if (!confirm('Are you sure you want to archive submission?')) return;

            this.loading = true;
            axios
                .post(this.archive_url)
                .then(this.back)
                .catch(() => {
                    Vue.$toast.open({
                        message: 'Something went wrong!',
                        type: 'error',
                    });
                });
        },

        restore() {
            this.loading = true;
            axios
                .post(this.restore_url)
                .then(this.back)
                .catch(() => {
                    Vue.$toast.open({
                        message: 'Something went wrong!',
                        type: 'error',
                    });
                });
        },

        openSignature() {
            this.$refs.signature_modal.open();
        },
    },
};
</script>
